import React from "react";
import RentProg from "../img/RentProg.png";

export default function RentProgIcon({ size }) {
  return (
    <div style={{ width: size ? size : "40px", height: size ? size : "40px" }}>
      <img style={{ width: "100%", height: "100%" }} src={RentProg} alt="" />
    </div>
  );
}
